<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_config.organization') }}</b-th>
                                                <b-td colspan="5">{{ getOrganizationById(budget_allocation.org_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.fiscal_year') }}</b-th>
                                                <b-td colspan="5">{{ getFiscalYearById(budget_allocation.fiscal_year_id) }}</b-td>
                                            </b-tr>
                                             <b-tr>
                                                <b-th colspan="1">{{ $t('grant_config.service_type') }}</b-th>
                                                <b-td colspan="5">{{ getServiceTypeById(budget_allocation.service_type_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_config.service_name') }}</b-th>
                                                <b-td colspan="5">{{ getServiceById(budget_allocation.service_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.total_budget') }}</b-th>
                                                <b-td colspan="5">{{ $n(budget_allocation.total_budget) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.available_budget') }}</b-th>
                                                <b-td colspan="5">{{ $n(budget_allocation.available_budget) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.committee_type') }}</b-th>
                                                <b-td colspan="5">{{ $i18n.locale === 'en' ? budget_allocation.committee_type === '2' ? 'Upazila' : 'District' : budget_allocation.committee_type === '2' ? 'উপজেলা' : 'জেলা'  }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('globalTrans.division') }}</b-th>
                                                <b-td colspan="5">{{ getDivisionById(budget_allocation.division_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('globalTrans.district') }}</b-th>
                                                <b-td colspan="5">{{ getDistrictById(budget_allocation.district_id) }}</b-td>
                                            </b-tr>
                                              <b-tr v-if="budget_allocation.upazilla_id">
                                                <b-th colspan="1">{{ $t('globalTrans.upazila') }}</b-th>
                                                <b-td colspan="5">{{ (currentLocale === 'en') ? budget_allocation.upazila_en : budget_allocation.upazila_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.bank_name') }}</b-th>
                                                <b-td colspan="5">{{ budget_allocation.bank_name }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.branch_name') }}</b-th>
                                                <b-td colspan="5">{{ (currentLocale === 'en') ? budget_allocation.branch_name : budget_allocation.branch_name_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.account_no') }}</b-th>
                                                <b-td colspan="5">{{ $n(budget_allocation.account_no, { useGrouping: false}) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.amount') }}</b-th>
                                                <b-td colspan="5">{{ $n(budget_allocation.amount) }}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="text-right">
                  <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-1')">{{ $t('globalTrans.cancel') }}</b-button>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// import Custom from '@/store/custom'

export default {
    props: ['id'],
    data () {
        return {
            budget_allocation: {}
        }
    },
    created () {
        this.budget_allocation = this.getBudget()
        this.loadingData = false
    },
    computed: {
      currentLocale: function () {
        return this.$i18n.locale
      }
    },
    methods: {
        getBudget () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return tmpData === undefined ? {} : JSON.parse(JSON.stringify(tmpData))
        },
        getOrganizationById (id) {
          const tmp = this.$store.state.orgList.find(item => item.value === id)
          return tmp ? tmp.text : ''
        },
        getFiscalYearById (id) {
          const tmp = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
          return tmp ? tmp.text : ''
        },
        getServiceTypeById (id) {
          const tmp = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList.find(item => item.value === id)
          if (tmp === undefined) return ''
          return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        },
        getServiceById (id) {
          const tmp = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.find(item => item.value === id)
          if (tmp === undefined) return ''
          return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        },
        getDivisionById (id) {
          const tmp = this.$store.state.commonObj.divisionList.find(item => item.value === id)
          if (tmp === undefined) return ''
          return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        },
        getDistrictById (id) {
          const tmp = this.$store.state.commonObj.districtList.find(item => item.value === id)
          if (tmp === undefined) return ''
          return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        },
        getUpazilaById (id) {
          const tmp = this.$store.state.commonObj.upazila.find(item => item.value === id)
          if (tmp === undefined) return ''
          return this.$i18n.locale === 'en' ? tmp.text_en : tmp.text_bn
        }
    }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
